import { render, staticRenderFns } from "./InvPT_Items.vue?vue&type=template&id=34b1f6c6"
import script from "./InvPT_Items.vue?vue&type=script&lang=js"
export * from "./InvPT_Items.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports